module.exports = __webpack_public_path__ + "img/apple.2662f3d7.webp";